/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandingPage } from './LandingPage';
import {
    LandingPageFromJSON,
    LandingPageFromJSONTyped,
    LandingPageToJSON,
    LandingPageToJSONTyped,
} from './LandingPage';

/**
 * Public representation of an agent available to the user.
 * @export
 * @interface AgentInfo
 */
export interface AgentInfo {
    /**
     * 
     * @type {string}
     * @memberof AgentInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgentInfo
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AgentInfo
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentInfo
     */
    isSelectable: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentInfo
     */
    parent?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentInfo
     */
    isPinned?: boolean;
    /**
     * 
     * @type {LandingPage}
     * @memberof AgentInfo
     */
    landingPage?: LandingPage | null;
}

/**
 * Check if a given object implements the AgentInfo interface.
 */
export function instanceOfAgentInfo(value: object): value is AgentInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isSelectable' in value) || value['isSelectable'] === undefined) return false;
    return true;
}

export function AgentInfoFromJSON(json: any): AgentInfo {
    return AgentInfoFromJSONTyped(json, false);
}

export function AgentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['display_name'],
        'description': json['description'],
        'isSelectable': json['is_selectable'],
        'parent': json['parent'] == null ? undefined : json['parent'],
        'isPinned': json['is_pinned'] == null ? undefined : json['is_pinned'],
        'landingPage': json['landing_page'] == null ? undefined : LandingPageFromJSON(json['landing_page']),
    };
}

export function AgentInfoToJSON(json: any): AgentInfo {
    return AgentInfoToJSONTyped(json, false);
}

export function AgentInfoToJSONTyped(value?: AgentInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'display_name': value['displayName'],
        'description': value['description'],
        'is_selectable': value['isSelectable'],
        'parent': value['parent'],
        'is_pinned': value['isPinned'],
        'landing_page': LandingPageToJSON(value['landingPage']),
    };
}

